module.exports = __webpack_public_path__ + "static/img/logo.5e2a1b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 11